export default "__VITE_ASSET___a0iq2fn__"